export default __webpack_public_path__ + "static/media/pic7.9d5f91f5.jpg";